module.exports = __webpack_public_path__ + "img/about_logo_12.eb8af373.png";